import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

const BORDER_COLOR = getThemeColor('foreground', theme.tints.light);

export const leftContainerClassName = css`
  justify-content: flex-end;
`;

export const mobileClassName = css`
  position: absolute;
  transform: translate(0, 0);
  transition: transform 0.27s, opacity 0.27s;
  padding: 0;
  opacity: 1;

  height: 48px;
  width: 52px;
  top: auto;
  bottom: -48px;
  z-index: 2;

  transform: translateX(100%);
  display: flex;
  justify-content: center;
  right: 10px;

  > button {
    width: 40px;
    height: 32px;
    background: transparent;
    border: 1px solid ${BORDER_COLOR};
    border-radius: 5px;
    padding: 0;
  }

  @media all and (orientation: portrait) {
    top: 50px;
    right: 0;
    transform: none;
    background: none;

    > button {
      width: 42px;
      height: 42px;
      margin: 0;
    }
  }
`;
